import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable } from 'rxjs/Rx';

import { GUID, Param } from "app/brightserve/brightserve.module";
import { Doctor } from "app/shared/shared.module";
import { User } from "app/shared/shared.module";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class AdminService {

    constructor(private http: HttpClient) { }

    GetDoctors(): Observable<Doctor[]> {
        var url = "/doctor/list";
        return this.http.get(url).map((res: any) => res.Doctors.map(i => new Doctor(i)) || {});
    }

    AddDoctor(doctor: Doctor): Observable<any> {
        var url = "/doctor/new";
        return this.http.post(url, { Doctor: doctor }).map((res: any) => res || {});
    }

    GetUsers(): Observable<User[]> {
        var url = "/user/list";
        return this.http.get(url).map((res: any) => res.Users.map(i => new User(i)) || {});
    }

    AddUser(user: User): Observable<any> {
        var url = "/user/new";
        return this.http.post(url, { User: user }).map((res: any) => res || {});
    }
}



// WEBPACK FOOTER //
// ./src/app/admin/admin.service.ts